export default __webpack_public_path__ + "static/media/Schwein-mit-Kleeblatt.a353735e.webp";